<template>
    <div>
        <div class="horizontal-item">
            <div>
                <div>
                    <div class="position-relative pt-3 px-3">
                        <small-carousel :images="images" :show-indicators="false" height="200px"></small-carousel>
                        <div class="circle-area" v-if="true || isOffertaSpeciale">
                            <p>Offerta Speciale</p>
                        </div>
                    </div>
                    <div class="px-3 pb-3">
                        <div class="pb-2">
                            <div class="type-info" :class="isHighlight? 'bg-primary' : ''">
                                <span>{{label}}</span>
                            </div>
                            <div class="d-flex">
                                <div class="date-info">
                                    <h3 class="m-0 cursive">{{day}}</h3>
                                    <h5 class="text-uppercase m-0">{{month}}</h5>
                                </div>
                                <div class="item-info">
                                    <h5 class="cursive">{{name}}</h5>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="detail-info">
                                <div>
                                    <span class="notti nowrap">
                                        <b>{{this.nights}}</b> notti - <b>{{this.days}}</b> giorni
                                    </span>
                                </div>
                                <div v-if="isPartenzaGarantita">
                                    <span v-if="isPartenzaGarantita" class="partenza-garantita">partenza garantita</span>
                                </div>
                            </div>
                            <div class="dates-info">
                                <div class="position-relative" v-if="isAltreDate">
                                    <a href="javascript:void(0)" class="dates text-primary" @click="showAltreDate = !showAltreDate">altre date disponibili</a>
                                    <div @mouseleave="showAltreDate = false" @click="showAltreDate = false" v-if="showAltreDate" class="position-absolute p-1 border rounded bg-white" style="z-index: 10; max-height: 130px; overflow: auto;">
                                        <button v-for="(item, index) in departureFutureDates" :key="index" @click="onOpenDetailWithDate(item)" style="width: 42px" class="rounded-0 mb-1 mx-1 px-1 btn btn-outline-primary btn-sm">{{formatDate(item)}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between pt-3 px-3">
                    <div>
                        <h6 class="text-uppercase mb-0">a partire da</h6>
                        <h1 class="currency">{{price}} &euro;</h1>
                    </div>
                    <div>
                        <button class="btn btn-primary btn-lg px-5" @click="onOpenDetail">scegli</button>
                    </div>
                </div>
            </div>
        </div>
        <ModalTourDetail :value="value" :is-home-page="true" ref="modalTourDetail" @select="onSelect" :is-camere-requested="isHomePage"/>
    </div>
</template>

<script>
import HorizontalItemTour from '../../../../widgets/common/tours/HorizontalItemTour'

export default {
  name: 'HorizontalItemTour',
  mixins: [HorizontalItemTour]
}
</script>



// WEBPACK FOOTER //
// src/front/components/mobile/widgets/common/tours/HorizontalItemTour.vue